import { useState } from "react"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { CategoryEntity } from "../../Objects/Category/CategoryEntity"

export const useCreateCategory = () => {
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)
  const [icon, setIcon] = useState("")

  const [category, setCategory] = useState<CategoryEntity | null>(null)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)
  const handleIconChange = (icon: string) => setIcon(icon)
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (category: CategoryEntity | null | undefined) => {
    if (category) {
      setCategory(category)
      setIcon(category.icon)
      setName(category.name)
      setDescription(category.description)
      setStatus(category.status)
    }
  }

  const handleSubmitForm = (): CategoryEntity | { errors: ValidationError[] } => {
    return new CategoryEntity({
      id: category?.id,
      status: status,
      name: name,
      description: description,
      icon: icon,
      displayOrder: category?.displayOrder ?? null,
    })
  }

  return {
    name,
    description,
    status,
    icon,
    handleNameChange,
    handleDescriptionChange,
    handleStatusChange,
    handleIconChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
